import { getIsLoggedIn } from '@config/state/globalSlices/userSlice';
import { Spinner } from '@phmg/storybook/v1/component';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

interface Props {
  isLoading: boolean;
}

export const PrivateRoute = ({ isLoading }: Props) => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const location = useLocation();

  // If the user req is loading we have to wait before rendering the outlet or redirecting
  // otherwise it will cause a flicker of the login page before the user data is loaded
  // A looking spinner could be used
  if (isLoading) {
    return <div className='h-screen w-screen flex justify-center pt-[40%]'><Spinner /></div>; // Optionally, you can return a loading spinner or placeholder here
  }

  return isLoggedIn ? <Outlet /> : <Navigate to="/ap/login" replace state={{ redirect: location.pathname }} />;
};
